function handleCartSubtotalEleInQbShowPriceWhenUseQB({
  cartSubtotalEle,
  cartData,
  newCartSubtotalPriceHtml,
}) {
  $(cartSubtotalEle).css("display", "none");
  $(cartSubtotalEle).css("font-size", "0");
}
window.BSS_B2B.addAction(
  "handle_cartSubtotalEle_in_qb_showPriceWhenUseQB",
  handleCartSubtotalEleInQbShowPriceWhenUseQB
);

if(typeof BSS_B2B != undefined) {
    if(window.location.pathname.includes("/cart")) {
        setTimeout(() =>{
            $('.cart__item--price').each(function() {
              let cartPriceElement = $(this).find('.cart__price.bss');
              let qbPriceElement = $(this).find('.bss-qb-price-item');
      
              if (cartPriceElement.length && qbPriceElement.length) {
                  let cartPrice = parseFloat(cartPriceElement.text().replace('€', '').replace(',', '.'));
                  let qbPrice = parseFloat(qbPriceElement.text().replace('€', '').replace(',', '.'));
                  if (cartPrice === qbPrice) {
                      cartPriceElement.hide();
                  }
              }
          });
        }, 4000)
    }
}


(() => {
  let counter = 0;
let selector = ".bss-b2b-discount-code-wrapper";
const interval = setInterval(() => {
    if ($(selector).length > 0) {
      $("#bss-b2b-discount-code-input").attr("placeholder", "Syötä alennuskoodi");
      $(".cart__footer-page").prepend($(".bss-b2b-discount-code-wrapper"));
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);
})();

document.addEventListener("get_cart_subtotal_bss", function(event) {
  $(".bss-discount-name-bogo").html($(".bss-discount-name-bogo").html().replace("Discount", 'alennus'))
});